const SVG_NS = 'http://www.w3.org/2000/svg';

let CONFIG;
let computePrice;
let formatPrice;
let S;
let DIM_KEYS;

function el(tag, props, children) {
  const node = document.createElement(tag);
  if (props) {
    Object.keys(props).forEach((k) => {
      const v = props[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') node.className = v;
      else if (k === 'text') node.textContent = v;
      else if (k === 'html') node.innerHTML = v;
      else if (k.startsWith('on')) node.addEventListener(k.slice(2).toLowerCase(), v);
      else if (v === true) node.setAttribute(k, '');
      else node.setAttribute(k, v);
    });
  }
  (children || []).forEach((c) => {
    if (c) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
  });
  return node;
}

function svgFromString(markup) {
  const wrapper = document.createElementNS(SVG_NS, 'svg');
  wrapper.innerHTML = markup;
  return wrapper;
}

function icon(name) {
  const paths = {
    check: '<polyline points="3 8.5 6.5 12 13 4.5"/>',
    info: '<circle cx="8" cy="8" r="7"/><line x1="8" y1="7" x2="8" y2="12"/><line x1="8" y1="4.5" x2="8" y2="4.6"/>',
    shield: '<path d="M8 1.5 2.5 3.6v4c0 3.2 2.2 6 5.5 6.9 3.3-.9 5.5-3.7 5.5-6.9v-4Z"/>',
    chevron: '<polyline points="3 6 8 11 13 6"/>',
    upload: '<path d="M8 12V3"/><polyline points="4 6.5 8 2.5 12 6.5"/><line x1="2.5" y1="13.5" x2="13.5" y2="13.5"/>',
    close: '<line x1="3.5" y1="3.5" x2="12.5" y2="12.5"/><line x1="12.5" y1="3.5" x2="3.5" y2="12.5"/>',
    arrow: '<line x1="2" y1="8" x2="13" y2="8"/><polyline points="9 4 13 8 9 12"/>',
    plus: '<line x1="8" y1="3.5" x2="8" y2="12.5"/><line x1="3.5" y1="8" x2="12.5" y2="8"/>'
  };
  const node = document.createElementNS(SVG_NS, 'svg');
  node.setAttribute('viewBox', '0 0 16 16');
  node.setAttribute('fill', 'none');
  node.setAttribute('stroke', 'currentColor');
  node.setAttribute('stroke-width', '1.6');
  node.setAttribute('stroke-linecap', 'round');
  node.setAttribute('stroke-linejoin', 'round');
  node.setAttribute('aria-hidden', 'true');
  node.setAttribute('focusable', 'false');
  node.innerHTML = paths[name] || '';
  return node;
}

function buildDiagram(assetBase) {
  const wrap = el('div', { class: 'ccfg-photo' });

  const src = assetBase || CONFIG.diagramImage;
  wrap.appendChild(el('img', { class: 'ccfg-photo-img', src, alt: CONFIG.diagramAlt || '' }));

  const lines = document.createElementNS(SVG_NS, 'svg');
  lines.setAttribute('class', 'ccfg-photo-lines');
  lines.setAttribute('viewBox', '0 0 100 100');
  lines.setAttribute('preserveAspectRatio', 'none');
  lines.setAttribute('aria-hidden', 'true');
  lines.innerHTML = (CONFIG.diagramCallouts || [])
    .map((c) => {
      const [x1, y1, x2, y2] = c.line;
      const dx = x2 - x1;
      const dy = y2 - y1;
      const len = Math.hypot(dx, dy) || 1;
      const tx = (-dy / len) * 1.1;
      const ty = (dx / len) * 1.1;
      const f = (n) => n.toFixed(2);
      return (
        `<g class="ccfg-cline" data-dim="${c.key}">` +
        `<line class="ccfg-cline-hit" x1="${f(x1)}" y1="${f(y1)}" x2="${f(x2)}" y2="${f(y2)}"/>` +
        `<line class="ccfg-cline-dark" x1="${f(x1)}" y1="${f(y1)}" x2="${f(x2)}" y2="${f(y2)}"/>` +
        `<line class="ccfg-cline-light" x1="${f(x1)}" y1="${f(y1)}" x2="${f(x2)}" y2="${f(y2)}"/>` +
        `<line class="ccfg-cline-tick" x1="${f(x1 - tx)}" y1="${f(y1 - ty)}" x2="${f(x1 + tx)}" y2="${f(y1 + ty)}"/>` +
        `<line class="ccfg-cline-tick" x1="${f(x2 - tx)}" y1="${f(y2 - ty)}" x2="${f(x2 + tx)}" y2="${f(y2 + ty)}"/>` +
        `</g>`
      );
    })
    .join('');
  wrap.appendChild(lines);

  const marks = el('div', { class: 'ccfg-marks' });
  (CONFIG.diagramCallouts || []).forEach((c) => {
    marks.appendChild(
      el('button', {
        type: 'button',
        class: 'ccfg-mark',
        'data-dim': c.key,
        'aria-label': 'Measurement ' + c.key,
        style: 'left:' + c.badge[0] + '%;top:' + c.badge[1] + '%',
        text: c.key
      })
    );
  });
  wrap.appendChild(marks);

  return wrap;
}

function artSlide(variant) {
  const scenes = {
    cover:
      '<rect class="ccfg-art-bg" x="0" y="0" width="400" height="400"/>' +
      '<path class="ccfg-art-fill" d="M60 250 H150 V180 H250 V250 H340 V300 H60 Z"/>' +
      '<path class="ccfg-art-stroke" d="M60 250 H150 V180 H250 V250 H340 V300 H60 Z"/>' +
      '<path class="ccfg-art-stroke" d="M60 275 H340"/>' +
      '<circle class="ccfg-art-accent" cx="200" cy="140" r="8"/>',
    weave:
      '<rect class="ccfg-art-bg" x="0" y="0" width="400" height="400"/>' +
      '<rect class="ccfg-art-fill" x="70" y="70" width="260" height="260"/>' +
      '<path class="ccfg-art-stroke" d="M70 120 H330 M70 170 H330 M70 220 H330 M70 270 H330 M120 70 V330 M170 70 V330 M220 70 V330 M270 70 V330"/>',
    tie:
      '<rect class="ccfg-art-bg" x="0" y="0" width="400" height="400"/>' +
      '<path class="ccfg-art-fill" d="M70 110 H330 V240 Q200 290 70 240 Z"/>' +
      '<path class="ccfg-art-stroke" d="M70 110 H330 V240 Q200 290 70 240 Z"/>' +
      '<path class="ccfg-art-stroke" d="M90 250 Q200 300 310 250"/>' +
      '<circle class="ccfg-art-accent" cx="200" cy="283" r="10"/>',
    grommet:
      '<rect class="ccfg-art-bg" x="0" y="0" width="400" height="400"/>' +
      '<rect class="ccfg-art-fill" x="70" y="140" width="260" height="120"/>' +
      '<path class="ccfg-art-stroke" d="M70 140 H330 V260 H70 Z"/>' +
      '<circle class="ccfg-art-stroke" cx="130" cy="200" r="16"/>' +
      '<circle class="ccfg-art-stroke" cx="200" cy="200" r="16"/>' +
      '<circle class="ccfg-art-stroke" cx="270" cy="200" r="16"/>'
  };
  return svgFromString(scenes[variant] || scenes.cover);
}

function tileArt(kind) {
  const band =
    '<rect class="ccfg-art-bg" x="0" y="0" width="240" height="160"/>' +
    '<path class="ccfg-art-fill" d="M20 30 H220 V96 Q120 126 20 96 Z"/>' +
    '<path class="ccfg-art-stroke" d="M20 30 H220 V96 Q120 126 20 96 Z"/>';
  const motifs = {
    drawstring: '<path class="ccfg-art-stroke" d="M30 104 Q120 134 210 104"/><circle class="ccfg-art-accent" cx="120" cy="126" r="7"/>',
    elastic: '<path class="ccfg-art-stroke" d="M28 100 q12 14 24 0 q12 14 24 0 q12 14 24 0 q12 14 24 0 q12 14 24 0 q12 14 24 0 q12 14 24 0 q12 14 24 0"/>',
    clip: '<rect class="ccfg-art-accent" x="96" y="106" width="48" height="18" rx="4"/><path class="ccfg-art-stroke" d="M108 124 V140 M132 124 V140"/>',
    both:
      '<path class="ccfg-art-stroke" d="M28 100 q12 12 24 0 q12 12 24 0 q12 12 24 0 q12 12 24 0 q12 12 24 0 q12 12 24 0 q12 12 24 0 q12 12 24 0"/>' +
      '<rect class="ccfg-art-accent" x="102" y="112" width="36" height="14" rx="4"/>',
    zipper:
      '<path class="ccfg-art-stroke" d="M120 30 V112"/>' +
      '<path class="ccfg-art-stroke" d="M112 44 H128 M112 60 H128 M112 76 H128 M112 92 H128"/>' +
      '<rect class="ccfg-art-accent" x="112" y="104" width="16" height="20" rx="3"/>',
    plain: '<path class="ccfg-art-stroke" d="M30 104 Q120 122 210 104"/>',
    g6: '<g class="ccfg-art-stroke"><circle cx="44" cy="86" r="7"/><circle cx="82" cy="90" r="7"/><circle cx="120" cy="92" r="7"/><circle cx="158" cy="90" r="7"/><circle cx="196" cy="86" r="7"/></g>',
    g12: '<g class="ccfg-art-stroke"><circle cx="60" cy="88" r="7"/><circle cx="120" cy="92" r="7"/><circle cx="180" cy="88" r="7"/></g>',
    g24: '<g class="ccfg-art-stroke"><circle cx="80" cy="90" r="7"/><circle cx="160" cy="90" r="7"/></g>'
  };
  const node = svgFromString(band + (motifs[kind] || motifs.plain));
  node.setAttribute('viewBox', '0 0 240 160');
  return node;
}

const TIE_ART = {
  drawstring: 'drawstring',
  'elastic-bottom': 'elastic',
  'push-clip': 'clip',
  'elastic-push-clip': 'both',
  'split-zipper': 'zipper',
  none: 'plain'
};

const GROMMET_ART = {
  none: 'plain',
  'every-6': 'g6',
  'every-12': 'g12',
  'every-24': 'g24'
};


function relativeLuminance(hex) {
  const h = String(hex || '').replace('#', '');
  if (h.length !== 6) return null;
  const c = [0, 2, 4].map((i) => {
    const v = parseInt(h.slice(i, i + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
}

function contrast(a, b) {
  const hi = Math.max(a, b);
  const lo = Math.min(a, b);
  return (hi + 0.05) / (lo + 0.05);
}

function bandInk(hex) {
  const L = relativeLuminance(hex);
  if (L === null) return 'dark';
  const onDark = contrast(L, relativeLuminance('#1b1b1b'));
  const onLight = contrast(L, relativeLuminance('#ffffff'));
  return onLight > onDark ? 'light' : 'dark';
}

function defaultState() {
  const dimensions = {};
  DIM_KEYS.forEach((k) => {
    dimensions[k] = '';
  });
  const colors = {};
  CONFIG.tiers.forEach((t) => {
    colors[t.id] = t.colors[0].name;
  });
  return {
    dimensions,
    tierId: CONFIG.tiers[0].id,
    colors,
    personalization: {
      type: 'none',
      text: '',
      font: CONFIG.personalization.defaultFont,
      color: CONFIG.personalization.defaultColor,
      sides: CONFIG.personalization.defaultSides.slice(),
      logoFileName: null
    },
    tieDown: CONFIG.tieDowns[0].id,
    grommets: CONFIG.grommets[0].id,
    specialRequest: '',
    quantity: 1,
    hadReferenceImages: false
  };
}

function isValidDim(raw) {
  if (raw === '' || raw === null || raw === undefined) return false;
  const v = parseFloat(raw);
  return Number.isFinite(v) && v >= CONFIG.limits.min && v <= CONFIG.limits.max;
}

function mount(root) {
  const state = defaultState();
  const files = [];
  const refs = {
    inputs: {},
    fields: {},
    errors: {},
    markers: {},
    tierPrices: {},
    tierBands: {},
    tierCards: {},
    swatchRows: {},
    slides: [],
    thumbs: []
  };
  let logoFile = null;
  let activeDim = null;
  let saveTimer = null;
  let frame = null;

  root.classList.add('ccfg-root');

  const restore = () => {
    let saved = null;
    try {
      saved = JSON.parse(localStorage.getItem(CONFIG.storageKey) || 'null');
    } catch (err) {
      saved = null;
    }
    if (!saved || typeof saved !== 'object') return;
    DIM_KEYS.forEach((k) => {
      if (typeof saved.dimensions?.[k] === 'string' || typeof saved.dimensions?.[k] === 'number') {
        state.dimensions[k] = String(saved.dimensions[k]);
      }
    });
    if (CONFIG.tiers.some((t) => t.id === saved.tierId)) state.tierId = saved.tierId;
    CONFIG.tiers.forEach((t) => {
      const name = saved.colors?.[t.id];
      if (t.colors.some((c) => c.name === name)) state.colors[t.id] = name;
    });
    if (saved.personalization && ['none', 'text', 'logo'].includes(saved.personalization.type)) {
      state.personalization.type = saved.personalization.type;
      state.personalization.text = String(saved.personalization.text || '').slice(0, CONFIG.personalization.maxTextLength);
      if (CONFIG.personalization.fonts.includes(saved.personalization.font)) {
        state.personalization.font = saved.personalization.font;
      }
      if (/^#[0-9a-fA-F]{6}$/.test(saved.personalization.color || '')) {
        state.personalization.color = saved.personalization.color;
      }
      if (Array.isArray(saved.personalization.sides)) {
        const keep = CONFIG.personalization.sides.filter((v) => saved.personalization.sides.indexOf(v) > -1);
        if (keep.length) state.personalization.sides = keep;
      }
    }
    if (CONFIG.tieDowns.some((o) => o.id === saved.tieDown)) state.tieDown = saved.tieDown;
    if (CONFIG.grommets.some((o) => o.id === saved.grommets)) state.grommets = saved.grommets;
    state.specialRequest = String(saved.specialRequest || '').slice(0, CONFIG.specialRequestMaxLength);
    const q = parseInt(saved.quantity, 10);
    if (Number.isFinite(q)) state.quantity = Math.min(CONFIG.limits.maxQuantity, Math.max(1, q));
    state.hadReferenceImages = Boolean(saved.hadReferenceImages);
  };

  const persist = () => {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
      try {
        localStorage.setItem(
          CONFIG.storageKey,
          JSON.stringify({
            dimensions: state.dimensions,
            tierId: state.tierId,
            colors: state.colors,
            personalization: { ...state.personalization, logoFileName: null },
            tieDown: state.tieDown,
            grommets: state.grommets,
            specialRequest: state.specialRequest,
            quantity: state.quantity,
            hadReferenceImages: files.length > 0
          })
        );
      } catch (err) {
        return;
      }
    }, 400);
  };

  restore();

  const tierById = (id) => CONFIG.tiers.find((t) => t.id === id) || CONFIG.tiers[0];
  const optionById = (list, id) => list.find((o) => o.id === id) || list[0];
  const allValid = () => DIM_KEYS.every((k) => isValidDim(state.dimensions[k]));

  const personalizationPrice = () => CONFIG.personalization.prices[state.personalization.type] || 0;

  const previewDimensions = () => (allValid() ? state.dimensions : CONFIG.placeholderDimensions || state.dimensions);

  const breakdown = (tier, dims) =>
    computePrice(dims || state.dimensions, tier, {
      tieDownPrice: optionById(CONFIG.tieDowns, state.tieDown).price,
      grommetsPrice: optionById(CONFIG.grommets, state.grommets).price,
      personalizationPrice: personalizationPrice(),
      quantity: state.quantity
    });

  const gallery = el('div', { class: 'ccfg-gallery' });
  const stage = el('div', { class: 'ccfg-stage' });
  const thumbs = el('div', { class: 'ccfg-thumbs', role: 'tablist', 'aria-label': 'Product gallery' });

  const slideDefs = CONFIG.galleryImages;

  const showSlide = (index) => {
    refs.slides.forEach((s, i) => s.setAttribute('data-active', String(i === index)));
    refs.thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
  };

  const addSlide = (content, thumbContent, label) => {
    const index = refs.slides.length;
    const slide = el('div', { class: 'ccfg-slide', 'data-active': String(index === 0), role: 'group', 'aria-label': label });
    slide.appendChild(content);
    stage.appendChild(slide);
    refs.slides.push(slide);

    const thumb = el('button', {
      type: 'button',
      class: 'ccfg-thumb',
      'aria-current': String(index === 0),
      'aria-label': label,
      onclick: () => showSlide(index)
    });
    thumb.appendChild(thumbContent);
    thumbs.appendChild(thumb);
    refs.thumbs.push(thumb);
  };

  const assetBase = root.getAttribute('data-ccfg-diagram') || '';
  const diagram = buildDiagram(assetBase);
  const diagramThumb = buildDiagram(assetBase);
  diagramThumb.setAttribute('aria-hidden', 'true');
  diagramThumb.querySelectorAll('.ccfg-mark, .ccfg-photo-lines').forEach((n) => n.remove());
  addSlide(diagram, diagramThumb, 'Measurement diagram');

  slideDefs.forEach((def, i) => {
    if (def.src) {
      const img = el('img', { src: def.src, alt: def.alt || '' });
      const thumbImg = el('img', { src: def.src, alt: '' });
      addSlide(img, thumbImg, def.alt || 'Product image ' + (i + 2));
      return;
    }
    const build = () => {
      const node = artSlide(def.art);
      node.setAttribute('viewBox', '0 0 400 400');
      return node;
    };
    addSlide(build(), build(), 'Product image ' + (i + 2));
  });

  if (refs.slides.length > 1) gallery.appendChild(thumbs);
  gallery.appendChild(stage);
  gallery.setAttribute('data-single', String(refs.slides.length < 2));

  diagram.querySelectorAll('.ccfg-mark').forEach((markEl) => {
    const key = markEl.getAttribute('data-dim');
    const lineEl = diagram.querySelector('.ccfg-cline[data-dim="' + key + '"]');
    refs.markers[key] = [markEl, lineEl].filter(Boolean);
    const activate = () => {
      const input = refs.inputs[key];
      if (!input) return;
      input.focus();
      input.select();
    };
    markEl.addEventListener('click', activate);
    if (lineEl) {
      lineEl.addEventListener('click', activate);
      lineEl.addEventListener('mouseenter', () => setActiveDim(key));
      lineEl.addEventListener('mouseleave', () => {
        if (activeDim === key && document.activeElement !== refs.inputs[key]) setActiveDim(null);
      });
    }
    markEl.addEventListener('mouseenter', () => setActiveDim(key));
    markEl.addEventListener('mouseleave', () => {
      if (activeDim === key && document.activeElement !== refs.inputs[key]) setActiveDim(null);
    });
  });

  const setActiveDim = (key) => {
    activeDim = key;
    Object.keys(refs.markers).forEach((k) => {
      refs.markers[k].forEach((n) => n.classList.toggle('ccfg-dim--active', k === key));
    });
    if (!key) return;
    showSlide(0);
    const rect = stage.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      stage.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  const syncMarkerFilled = (key) => {
    const nodes = refs.markers[key];
    if (!nodes) return;
    const on = isValidDim(state.dimensions[key]);
    nodes.forEach((n) => n.classList.toggle('ccfg-dim--filled', on));
  };

  const column = el('div', { class: 'ccfg-column' });

  column.appendChild(el('h1', { class: 'ccfg-title', text: CONFIG.productTitle }));

  const priceLive = el('div', { class: 'ccfg-visually-hidden', 'aria-live': 'polite', 'aria-atomic': 'true' });
  column.appendChild(priceLive);

  const legend = (number, text, aside) => {
    const nodes = [el('span', { class: 'ccfg-num', text: String(number), 'aria-hidden': 'true' }), el('span', { class: 'ccfg-legend-text', text })];
    if (aside) nodes.push(aside);
    return el('legend', { class: 'ccfg-legend' }, nodes);
  };

  const step1 = el('fieldset', { class: 'ccfg-step' });
  step1.appendChild(
    legend(1, S.sectionMeasurement.replace(/^1\.\s*/, ''), el('span', { class: 'ccfg-legend-aside', text: CONFIG.measuringGuideLabel }))
  );

  const dimsGrid = el('div', { class: 'ccfg-dims' });
  CONFIG.dimensions.forEach((dim) => {
    const inputId = 'ccfg-dim-' + dim.key;
    const errorId = inputId + '-error';
    const field = el('div', { class: 'ccfg-field', 'data-key': dim.key, 'data-filled': 'false' });
    const error = el('p', { class: 'ccfg-error', id: errorId, role: 'alert' });
    const input = el('input', {
      type: 'number',
      inputmode: 'decimal',
      step: String(CONFIG.limits.step),
      min: String(CONFIG.limits.min),
      max: String(CONFIG.limits.max),
      required: true,
      id: inputId,
      class: 'ccfg-input',
      'aria-describedby': errorId,
      placeholder: CONFIG.placeholderDimensions ? String(CONFIG.placeholderDimensions[dim.key]) : null,
      value: state.dimensions[dim.key]
    });

    field.appendChild(
      el('div', { class: 'ccfg-field-head' }, [
        el('span', { class: 'ccfg-letter', text: dim.key, 'aria-hidden': 'true' }),
        el('label', { class: 'ccfg-field-label', for: inputId, text: dim.label })
      ])
    );
    field.appendChild(
      el('span', { class: 'ccfg-input-wrap' }, [input, el('span', { class: 'ccfg-suffix', text: CONFIG.unitSuffix })])
    );
    field.appendChild(error);
    dimsGrid.appendChild(field);

    refs.inputs[dim.key] = input;
    refs.fields[dim.key] = field;
    refs.errors[dim.key] = error;

    input.addEventListener('wheel', (e) => e.preventDefault(), { passive: false });
    input.addEventListener('focus', () => setActiveDim(dim.key));
    input.addEventListener('blur', () => {
      if (activeDim === dim.key) setActiveDim(null);
      const raw = input.value.trim();
      if (raw !== '' && isValidDim(raw)) {
        input.value = String(Math.round(parseFloat(raw) * 10) / 10);
        state.dimensions[dim.key] = input.value;
      }
      showError(dim.key, true);
      update();
    });
    input.addEventListener('input', () => {
      const cleaned = input.value.replace(/[^0-9.]/g, '');
      if (cleaned !== input.value) input.value = cleaned;
      state.dimensions[dim.key] = input.value.trim();
      setActiveDim(dim.key);
      showError(dim.key, false);
      update();
    });
  });

  step1.appendChild(dimsGrid);

  const warn = el('p', { class: 'ccfg-warn', hidden: true, role: 'alert' }, [icon('info'), el('span', { text: S.warnCenterWidth })]);
  step1.appendChild(warn);

  step1.appendChild(
    el('div', { class: 'ccfg-callout' }, [
      icon('info'),
      el('div', {}, [el('p', { text: S.infoCalloutLine1 }), el('p', { text: S.infoCalloutLine2 })])
    ])
  );
  column.appendChild(step1);

  const showError = (key, onBlur) => {
    const raw = state.dimensions[key];
    const input = refs.inputs[key];
    const error = refs.errors[key];
    let message = '';
    if (onBlur) {
      if (raw === '') message = S.errorRequired;
      else if (!isValidDim(raw)) message = S.errorRange;
    }
    error.textContent = message;
    error.setAttribute('data-shown', String(Boolean(message)));
    input.setAttribute('aria-invalid', String(Boolean(message)));
    refs.fields[key].setAttribute('data-filled', String(isValidDim(raw)));
    syncMarkerFilled(key);
  };

  const step2 = el('fieldset', { class: 'ccfg-step' });
  const selectedTierName = el('span', { class: 'ccfg-selected-tier' });
  step2.appendChild(legend(2, S.sectionFabric.replace(/^2\.\s*/, ''), selectedTierName));

  const tiersWrap = el('div', { class: 'ccfg-tiers', role: 'radiogroup', 'aria-label': S.sectionFabric });

  CONFIG.tiers.forEach((tier) => {
    const card = el('div', {
      class: 'ccfg-tier',
      role: 'radio',
      'aria-checked': String(tier.id === state.tierId),
      tabindex: tier.id === state.tierId ? '0' : '-1',
      'data-tier': tier.id
    });

    const price = el('div', { class: 'ccfg-tier-price', text: '-' });
    refs.tierPrices[tier.id] = price;

    const bandText = el('div', {}, [
      tier.badge ? el('span', { class: 'ccfg-ribbon', text: tier.badge }) : null,
      el('h3', { class: 'ccfg-tier-name', text: tier.name }),
      price
    ]);
    const band = el('div', { class: 'ccfg-tier-band' }, [
      bandText,
      el('span', { class: 'ccfg-tier-check' }, [icon('check')])
    ]);
    refs.tierBands[tier.id] = band;
    card.appendChild(band);

    const inner = el('div', { class: 'ccfg-tier-inner' });
    card.appendChild(inner);

    inner.appendChild(
      el('div', { class: 'ccfg-tier-meta' }, [
        el('span', { class: 'ccfg-warranty' }, [icon('shield'), el('span', { text: tier.warranty })]),
        el('span', { class: 'ccfg-climate', text: tier.climateTag })
      ])
    );

    const swatchLabel = el('div', { class: 'ccfg-swatch-label' });
    const swatchRow = el('div', { class: 'ccfg-swatches', role: 'radiogroup', 'aria-label': 'Color' });
    tier.colors.forEach((color) => {
      const swatch = el('button', {
        type: 'button',
        class: 'ccfg-swatch',
        role: 'radio',
        'aria-checked': String(color.name === state.colors[tier.id]),
        'aria-label': color.name,
        style: 'background-color:' + color.hex,
        onclick: (e) => {
          e.stopPropagation();
          state.colors[tier.id] = color.name;
          syncSwatches(tier);
          update();
        }
      });
      swatch.appendChild(icon('check'));
      swatchRow.appendChild(swatch);
    });
    refs.swatchRows[tier.id] = { label: swatchLabel, row: swatchRow };
    inner.appendChild(swatchLabel);
    inner.appendChild(swatchRow);

    const ratings = el('div', { class: 'ccfg-ratings' });
    Object.keys(S.ratingLabels).forEach((key) => {
      const value = tier.ratings[key] || 0;
      const bars = el('span', { class: 'ccfg-bars', role: 'img', 'aria-label': S.ratingLabels[key] + ': ' + value + ' out of 5' });
      for (let i = 0; i < 5; i += 1) bars.appendChild(el('span', { class: 'ccfg-bar', 'data-on': String(i < value) }));
      ratings.appendChild(el('div', { class: 'ccfg-rating' }, [el('span', { text: S.ratingLabels[key] }), bars]));
    });
    inner.appendChild(ratings);

    const bodyId = 'ccfg-material-' + tier.id;
    const body = el('div', { class: 'ccfg-disclosure-body', id: bodyId, hidden: true }, [
      el('p', { text: tier.material }),
      el('ul', {}, tier.features.map((f) => el('li', { text: f })))
    ]);
    const toggle = el('button', {
      type: 'button',
      class: 'ccfg-disclosure-btn',
      'aria-expanded': 'false',
      'aria-controls': bodyId,
      onclick: (e) => {
        e.stopPropagation();
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        body.hidden = open;
      }
    });
    toggle.appendChild(el('span', { text: S.materialToggle }));
    toggle.appendChild(icon('chevron')).classList.add('ccfg-chevron');
    inner.appendChild(el('div', { class: 'ccfg-disclosure' }, [toggle, body]));

    card.addEventListener('click', () => selectTier(tier.id));
    card.addEventListener('keydown', (e) => radioKeydown(e, tiersWrap, '[role="radio"][data-tier]', (node) => selectTier(node.getAttribute('data-tier'))));

    refs.tierCards[tier.id] = card;
    tiersWrap.appendChild(card);
  });

  step2.appendChild(tiersWrap);
  column.appendChild(step2);

  const syncSwatches = (tier) => {
    const set = refs.swatchRows[tier.id];
    const name = state.colors[tier.id];
    set.label.textContent = S.colorLabel + ' ' + name;
    Array.from(set.row.children).forEach((sw) => {
      sw.setAttribute('aria-checked', String(sw.getAttribute('aria-label') === name));
    });
    const swatch = tier.colors.find((c) => c.name === name) || tier.colors[0];
    const band = refs.tierBands[tier.id];
    if (band && swatch) {
      band.style.setProperty('--ccfg-band', swatch.hex);
      band.setAttribute('data-ink', bandInk(swatch.hex));
    }
  };

  const selectTier = (id) => {
    state.tierId = id;
    CONFIG.tiers.forEach((t) => {
      const card = refs.tierCards[t.id];
      card.setAttribute('aria-checked', String(t.id === id));
      card.setAttribute('tabindex', t.id === id ? '0' : '-1');
    });
    update();
  };

  function radioKeydown(e, container, selector, onSelect) {
    const nodes = Array.from(container.querySelectorAll(selector));
    const current = nodes.indexOf(e.currentTarget);
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onSelect(e.currentTarget);
      return;
    }
    let next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % nodes.length;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + nodes.length) % nodes.length;
    if (next < 0) return;
    e.preventDefault();
    onSelect(nodes[next]);
    nodes[next].focus();
  }

  const P = CONFIG.personalization;
  const step3 = el('fieldset', { class: 'ccfg-step' });

  const personalizePrice = el('span', { class: 'ccfg-step-price' });
  const personalizeSwitch = el('input', {
    type: 'checkbox',
    class: 'ccfg-step-switch',
    'aria-label': S.personalizationEnable
  });
  step3.appendChild(
    legend(3, S.sectionPersonalize.replace(/^3\.\s*/, ''), el('span', { class: 'ccfg-step-aside' }, [personalizePrice, personalizeSwitch]))
  );

  const personalizeBody = el('div', { class: 'ccfg-panel', hidden: true });

  const modeRow = el('div', { class: 'ccfg-choices' });
  [
    ['text', S.personalizationText],
    ['logo', S.personalizationLogo]
  ].forEach(([value, label]) => {
    const input = el('input', {
      type: 'radio',
      name: 'ccfg-personalization',
      value,
      checked: state.personalization.type === value,
      onchange: () => {
        state.personalization.type = value;
        syncPersonalization();
        update();
      }
    });
    modeRow.appendChild(el('label', { class: 'ccfg-choice' }, [input, el('span', { text: label })]));
  });
  personalizeBody.appendChild(modeRow);

  const textField = el('div', { class: 'ccfg-pers-text', hidden: true });

  const fontSelect = el(
    'select',
    { class: 'ccfg-select', id: 'ccfg-personalization-font', 'aria-label': S.personalizationFontLabel },
    P.fonts.map((f) => el('option', { value: f, text: f, selected: f === state.personalization.font }))
  );
  fontSelect.addEventListener('change', () => {
    state.personalization.font = fontSelect.value;
    renderPreview();
    persist();
  });

  const colorInput = el('input', {
    type: 'color',
    class: 'ccfg-color-input',
    id: 'ccfg-personalization-color',
    value: state.personalization.color,
    'aria-label': S.personalizationColorLabel
  });
  const colorDot = el('span', { class: 'ccfg-color-dot' });
  const colorValue = el('span', { class: 'ccfg-color-value', text: state.personalization.color });
  const syncColor = () => {
    colorDot.style.backgroundColor = state.personalization.color;
    colorValue.textContent = state.personalization.color;
  };
  colorInput.addEventListener('input', () => {
    state.personalization.color = colorInput.value;
    syncColor();
    renderPreview();
    persist();
  });
  const colorField = el('label', { class: 'ccfg-color-field', for: 'ccfg-personalization-color' }, [
    colorDot,
    colorValue,
    colorInput
  ]);
  syncColor();

  textField.appendChild(el('div', { class: 'ccfg-pers-row' }, [fontSelect, colorField]));

  const textInput = el('input', {
    type: 'text',
    class: 'ccfg-text-input',
    id: 'ccfg-personalization-text',
    maxlength: String(P.maxTextLength),
    placeholder: S.personalizationTextPlaceholder,
    value: state.personalization.text
  });
  const textCounter = el('span', {
    class: 'ccfg-counter',
    text: state.personalization.text.length + '/' + P.maxTextLength
  });
  textInput.addEventListener('input', () => {
    state.personalization.text = textInput.value;
    textCounter.textContent = textInput.value.length + '/' + P.maxTextLength;
    renderPreview();
    persist();
  });
  textField.appendChild(textInput);
  textField.appendChild(textCounter);

  const buildSides = () => {
    const row = el('div', { class: 'ccfg-sides' }, [
      el('span', { class: 'ccfg-sides-label', text: S.personalizationSidesLabel })
    ]);
    P.sides.forEach((side) => {
      const box = el('input', {
        type: 'checkbox',
        checked: state.personalization.sides.indexOf(side) > -1,
        onchange: (e) => {
          const on = e.target.checked;
          const list = state.personalization.sides.filter((v) => v !== side);
          if (on) list.push(side);
          state.personalization.sides = P.sides.filter((v) => list.indexOf(v) > -1);
          syncSides();
          persist();
        }
      });
      row.appendChild(el('label', { class: 'ccfg-side', 'data-side': side }, [box, el('span', { text: side })]));
    });
    return row;
  };

  const textSides = buildSides();
  textField.appendChild(textSides);

  textField.appendChild(el('span', { class: 'ccfg-preview-label', text: S.personalizationPreviewLabel }));
  const previewText = el('span', { class: 'ccfg-preview-text' });
  const preview = el('div', { class: 'ccfg-preview' }, [previewText]);
  textField.appendChild(preview);
  textField.appendChild(el('p', { class: 'ccfg-preview-note', text: S.personalizationPreviewNote }));

  const logoField = el('div', { class: 'ccfg-pers-logo', hidden: true });
  const logoInput = el('input', {
    type: 'file',
    class: 'ccfg-visually-hidden',
    accept: S.logoAccept,
    id: 'ccfg-logo-input',
    tabindex: '-1'
  });
  const logoName = el('div', { class: 'ccfg-filename', hidden: true });
  const logoError = el('p', { class: 'ccfg-notice' });

  const renderLogoName = () => {
    logoName.textContent = '';
    if (!logoFile) {
      logoName.hidden = true;
      return;
    }
    logoName.hidden = false;
    logoName.appendChild(el('span', { text: logoFile.name }));
    logoName.appendChild(
      el('button', {
        type: 'button',
        class: 'ccfg-linkbtn',
        text: S.removeLabel,
        onclick: () => {
          logoFile = null;
          state.personalization.logoFileName = null;
          logoInput.value = '';
          renderLogoName();
          update();
        }
      })
    );
  };

  const acceptLogo = (file) => {
    logoError.textContent = '';
    if (!file) return;
    if (file.size > P.logoMaxBytes) {
      logoError.textContent = file.name + ' ' + S.uploadRejectSize;
      logoInput.value = '';
      return;
    }
    logoFile = file;
    state.personalization.logoFileName = file.name;
    renderLogoName();
    update();
  };

  logoInput.addEventListener('change', () => acceptLogo(logoInput.files && logoInput.files[0]));

  const logoDrop = el('div', {
    class: 'ccfg-dropzone',
    role: 'button',
    tabindex: '0',
    'aria-label': S.personalizationLogoDropTitle,
    onclick: (e) => {
      if (e.target.closest('.ccfg-btn')) return;
      logoInput.click();
    },
    onkeydown: (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        logoInput.click();
      }
    }
  });
  ['dragenter', 'dragover'].forEach((t) =>
    logoDrop.addEventListener(t, (e) => {
      e.preventDefault();
      logoDrop.setAttribute('data-dragover', 'true');
    })
  );
  ['dragleave', 'drop'].forEach((t) =>
    logoDrop.addEventListener(t, (e) => {
      e.preventDefault();
      logoDrop.setAttribute('data-dragover', 'false');
    })
  );
  logoDrop.addEventListener('drop', (e) => {
    acceptLogo(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
  });

  logoDrop.appendChild(el('span', { class: 'ccfg-drop-icon' }, [icon('upload')]));
  logoDrop.appendChild(el('span', { class: 'ccfg-dropzone-title', text: S.personalizationLogoDropTitle }));
  logoDrop.appendChild(el('span', { class: 'ccfg-dropzone-help', text: S.logoMaxLabel }));
  logoDrop.appendChild(
    el('button', { type: 'button', class: 'ccfg-btn', text: S.personalizationLogoButton, onclick: () => logoInput.click() })
  );

  const logoSides = buildSides();
  logoField.appendChild(logoInput);
  logoField.appendChild(logoDrop);
  logoField.appendChild(logoName);
  logoField.appendChild(logoError);
  logoField.appendChild(logoSides);

  personalizeBody.appendChild(textField);
  personalizeBody.appendChild(logoField);
  step3.appendChild(personalizeBody);

  function renderPreview() {
    const value = state.personalization.text;
    previewText.textContent = value || S.personalizationPreviewEmpty;
    previewText.setAttribute('data-empty', String(!value));
    previewText.style.fontFamily = state.personalization.font + ', sans-serif';
    previewText.style.color = state.personalization.color;
    const tier = tierById(state.tierId);
    const swatch = tier.colors.find((c) => c.name === state.colors[tier.id]) || tier.colors[0];
    if (swatch) preview.style.setProperty('--ccfg-preview-bg', swatch.hex);
  }

  function syncSides() {
    [textSides, logoSides].forEach((row) => {
      row.querySelectorAll('.ccfg-side').forEach((label) => {
        const on = state.personalization.sides.indexOf(label.getAttribute('data-side')) > -1;
        label.querySelector('input').checked = on;
        label.setAttribute('data-on', String(on));
      });
    });
  }

  function syncPersonalization() {
    const on = state.personalization.type !== 'none';
    personalizeSwitch.checked = on;
    personalizeBody.hidden = !on;
    textField.hidden = state.personalization.type !== 'text';
    logoField.hidden = state.personalization.type !== 'logo';
    personalizePrice.textContent = formatPrice(P.prices[state.personalization.type] || 0);
    personalizePrice.hidden = !on;
    modeRow.querySelectorAll('input').forEach((r) => {
      r.checked = r.value === state.personalization.type;
    });
    renderPreview();
    syncSides();
  }

  personalizeSwitch.addEventListener('change', () => {
    if (personalizeSwitch.checked) {
      state.personalization.type = 'text';
    } else {
      state.personalization.type = 'none';
      state.personalization.text = '';
      state.personalization.logoFileName = null;
      logoFile = null;
      textInput.value = '';
      logoInput.value = '';
      textCounter.textContent = '0/' + P.maxTextLength;
      renderLogoName();
    }
    syncPersonalization();
    update();
  });

  syncPersonalization();
  column.appendChild(step3);

  const buildTileGroup = (number, heading, options, artMap, getValue, setValue) => {
    const step = el('fieldset', { class: 'ccfg-step' });
    step.appendChild(legend(number, heading));
    const group = el('div', { class: 'ccfg-tiles', role: 'radiogroup', 'aria-label': heading });
    options.forEach((option) => {
      const tile = el('div', {
        class: 'ccfg-tile',
        role: 'radio',
        'data-id': option.id,
        'aria-checked': String(option.id === getValue()),
        tabindex: option.id === getValue() ? '0' : '-1'
      });
      const media = el('div', { class: 'ccfg-tile-media' });
      if (option.image) media.appendChild(el('img', { src: option.image, alt: '' }));
      else media.appendChild(tileArt(artMap[option.id]));
      tile.appendChild(media);
      tile.appendChild(
        el('span', { class: 'ccfg-tile-check' }, [
          el('span', { class: 'ccfg-tile-plus' }, [icon('plus')]),
          el('span', { class: 'ccfg-tile-tick' }, [icon('check')])
        ])
      );
      tile.appendChild(el('span', { class: 'ccfg-tile-name', text: option.label }));
      tile.appendChild(el('span', { class: 'ccfg-tile-price', text: option.price > 0 ? formatPrice(option.price) : '' }));

      const choose = (node) => {
        setValue(node.getAttribute('data-id'));
        Array.from(group.children).forEach((child) => {
          const on = child.getAttribute('data-id') === getValue();
          child.setAttribute('aria-checked', String(on));
          child.setAttribute('tabindex', on ? '0' : '-1');
        });
        update();
      };

      tile.addEventListener('click', () => choose(tile));
      tile.addEventListener('keydown', (e) => radioKeydown(e, group, '[role="radio"][data-id]', choose));
      group.appendChild(tile);
    });
    step.appendChild(group);
    return step;
  };

  column.appendChild(
    buildTileGroup(4, S.sectionTieDowns.replace(/^4\.\s*/, ''), CONFIG.tieDowns, TIE_ART, () => state.tieDown, (v) => {
      state.tieDown = v;
    })
  );
  column.appendChild(
    buildTileGroup(5, S.sectionGrommets.replace(/^5\.\s*/, ''), CONFIG.grommets, GROMMET_ART, () => state.grommets, (v) => {
      state.grommets = v;
    })
  );

  const step6 = el('fieldset', { class: 'ccfg-step' });
  step6.appendChild(legend(6, S.sectionUpload.replace(/^6\.\s*/, ''), el('span', { class: 'ccfg-pill', text: S.optionalPill })));

  const filesInput = el('input', {
    type: 'file',
    class: 'ccfg-visually-hidden',
    accept: CONFIG.referenceUpload.accept,
    multiple: true,
    id: 'ccfg-reference-input',
    tabindex: '-1'
  });
  const filesGrid = el('div', { class: 'ccfg-files' });
  const filesNotice = el('p', { class: 'ccfg-notice', role: 'alert' });

  const renderFiles = () => {
    filesGrid.textContent = '';
    files.forEach((entry, index) => {
      filesGrid.appendChild(
        el('div', { class: 'ccfg-file' }, [
          el('img', { src: entry.url, alt: entry.file.name }),
          el('button', {
            type: 'button',
            class: 'ccfg-file-remove',
            'aria-label': S.removeLabel + ' ' + entry.file.name,
            onclick: () => {
              URL.revokeObjectURL(entry.url);
              files.splice(index, 1);
              renderFiles();
              persist();
            }
          }, [icon('close')])
        ])
      );
    });
  };

  const acceptFiles = (list) => {
    filesNotice.textContent = '';
    const allowed = ['image/jpeg', 'image/png', 'image/gif'];
    Array.from(list).forEach((file) => {
      if (files.length >= CONFIG.referenceUpload.maxFiles) {
        filesNotice.textContent = S.uploadRejectCount;
        return;
      }
      if (!allowed.includes(file.type)) {
        filesNotice.textContent = file.name + ' ' + S.uploadRejectType;
        return;
      }
      if (file.size > CONFIG.referenceUpload.maxBytes) {
        filesNotice.textContent = file.name + ' ' + S.uploadRejectSize;
        return;
      }
      files.push({ file, url: URL.createObjectURL(file) });
    });
    state.hadReferenceImages = files.length > 0;
    renderFiles();
    persist();
  };

  filesInput.addEventListener('change', () => {
    acceptFiles(filesInput.files || []);
    filesInput.value = '';
  });

  const dropzone = el('div', {
    class: 'ccfg-dropzone',
    role: 'button',
    tabindex: '0',
    'aria-label': S.dropzoneTitle,
    onclick: (e) => {
      if (e.target.closest('.ccfg-btn')) return;
      filesInput.click();
    },
    onkeydown: (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        filesInput.click();
      }
    }
  });
  ['dragenter', 'dragover'].forEach((type) =>
    dropzone.addEventListener(type, (e) => {
      e.preventDefault();
      dropzone.setAttribute('data-dragover', 'true');
    })
  );
  ['dragleave', 'drop'].forEach((type) =>
    dropzone.addEventListener(type, (e) => {
      e.preventDefault();
      dropzone.setAttribute('data-dragover', 'false');
    })
  );
  dropzone.addEventListener('drop', (e) => {
    if (e.dataTransfer && e.dataTransfer.files) acceptFiles(e.dataTransfer.files);
  });

  dropzone.appendChild(icon('upload'));
  dropzone.appendChild(el('span', { class: 'ccfg-dropzone-title', text: S.dropzoneTitle }));
  dropzone.appendChild(el('span', { class: 'ccfg-dropzone-help', text: S.dropzoneHelp }));
  dropzone.appendChild(el('button', { type: 'button', class: 'ccfg-btn', text: S.dropzoneButton, onclick: () => filesInput.click() }));

  step6.appendChild(filesInput);
  step6.appendChild(dropzone);
  step6.appendChild(filesGrid);
  step6.appendChild(filesNotice);
  step6.appendChild(el('p', { class: 'ccfg-help', text: S.uploadHelp }));
  if (state.hadReferenceImages) step6.appendChild(el('p', { class: 'ccfg-notice', text: S.reattachNotice }));
  column.appendChild(step6);

  const requestBodyId = 'ccfg-request-body';
  const requestBody = el('div', { class: 'ccfg-accordion-body', id: requestBodyId, hidden: true });
  const requestToggle = el('button', {
    type: 'button',
    class: 'ccfg-disclosure-btn',
    'aria-expanded': 'false',
    'aria-controls': requestBodyId,
    onclick: () => {
      const open = requestToggle.getAttribute('aria-expanded') === 'true';
      requestToggle.setAttribute('aria-expanded', String(!open));
      requestBody.hidden = open;
    }
  });
  requestToggle.appendChild(el('span', { text: S.specialRequestHeading }));
  requestToggle.appendChild(icon('chevron')).classList.add('ccfg-chevron');

  const requestArea = el('textarea', {
    class: 'ccfg-textarea',
    id: 'ccfg-special-request',
    maxlength: String(CONFIG.specialRequestMaxLength),
    'aria-label': S.specialRequestHeading
  });
  requestArea.value = state.specialRequest;
  const requestCounter = el('span', {
    class: 'ccfg-counter',
    text: state.specialRequest.length + '/' + CONFIG.specialRequestMaxLength
  });
  requestArea.addEventListener('input', () => {
    state.specialRequest = requestArea.value;
    requestCounter.textContent = requestArea.value.length + '/' + CONFIG.specialRequestMaxLength;
    persist();
  });
  requestBody.appendChild(requestArea);
  requestBody.appendChild(requestCounter);
  column.appendChild(el('div', { class: 'ccfg-accordion' }, [requestToggle, requestBody]));

  const qtyInputs = [];
  const setQty = (value) => {
    const next = Math.min(CONFIG.limits.maxQuantity, Math.max(1, Math.round(value) || 1));
    state.quantity = next;
    qtyInputs.forEach((n) => {
      n.value = String(next);
    });
    update();
  };

  const buildQty = (variant) => {
    const input = el('input', {
      type: 'number',
      min: '1',
      max: String(CONFIG.limits.maxQuantity),
      step: '1',
      value: String(state.quantity),
      'aria-label': S.quantityLabel
    });
    input.addEventListener('wheel', (e) => e.preventDefault(), { passive: false });
    input.addEventListener('change', () => setQty(parseInt(input.value, 10)));
    qtyInputs.push(input);
    return el('div', { class: variant ? 'ccfg-qty ' + variant : 'ccfg-qty' }, [
      el('button', { type: 'button', 'aria-label': 'Decrease quantity', text: '−', onclick: () => setQty(state.quantity - 1) }),
      input,
      el('button', { type: 'button', 'aria-label': 'Increase quantity', text: '+', onclick: () => setQty(state.quantity + 1) })
    ]);
  };

  const status = el('p', { class: 'ccfg-status', role: 'status' });
  column.appendChild(status);
  column.appendChild(
    el('p', { class: 'ccfg-reset' }, [
      el('button', {
        type: 'button',
        class: 'ccfg-linkbtn',
        text: S.resetLabel,
        onclick: () => {
          if (!window.confirm(S.resetConfirm)) return;
          try {
            localStorage.removeItem(CONFIG.storageKey);
          } catch (err) {
            return;
          }
          window.location.reload();
        }
      })
    ])
  );

  const stickyTotal = el('span', { class: 'ccfg-sticky-total', text: '-' });
  const stickyAtc = el('button', { type: 'button', class: 'ccfg-atc', text: S.addToCart });
  const shipIconRaw = root.getAttribute('data-ccfg-shipicon');
  if (shipIconRaw) {
    let shipIconUrl = shipIconRaw;
    try {
      shipIconUrl = new URL(shipIconRaw, document.baseURI).href;
    } catch (err) {
      shipIconUrl = shipIconRaw;
    }
    root.style.setProperty('--ccfg-ship-icon', 'url("' + shipIconUrl + '")');
  }
  const stickyShip = el('span', { class: 'ccfg-sticky-ship' }, [
    el('span', { class: 'ccfg-ship-icon', 'aria-hidden': 'true' }),
    el('span', { class: 'ccfg-sticky-ship-text' }, [
      el('strong', { text: S.freeShippingTitle }),
      el('span', { text: S.freeShippingNote + ' $' + CONFIG.freeShippingThreshold })
    ])
  ]);
  const sticky = el('div', { class: 'ccfg-sticky' }, [
    stickyShip,
    stickyTotal,
    buildQty('ccfg-qty--onDark'),
    stickyAtc
  ]);

  const layout = el('div', { class: 'ccfg-layout' }, [gallery, column]);
  root.textContent = '';
  root.appendChild(layout);
  column.appendChild(sticky);

  const cartAddUrl = (root.getAttribute('data-ccfg-cart-add') || '/cart/add') + '.js';
  const cartUrl = root.getAttribute('data-ccfg-cart-url') || '/cart';
  const variantId = parseInt(root.getAttribute('data-ccfg-variant'), 10);
  let submitting = false;

  const ladderNodeId = root.getAttribute('data-ccfg-variants');
  const ladderDeclared = !!(ladderNodeId && document.getElementById(ladderNodeId));

  const variantLadder = (() => {
    const node = ladderDeclared && document.getElementById(ladderNodeId);
    if (!node) return null;
    let rows;
    try {
      rows = JSON.parse(node.textContent);
    } catch (err) {
      console.error('[cover-configurator] variant price ladder is not valid JSON.', err);
      return null;
    }
    if (!Array.isArray(rows) || rows.length < 2) return null;
    const ladder = rows
      .map((r) => ({ cents: Number(r[0]), id: Number(r[1]) }))
      .filter((r) => Number.isFinite(r.cents) && Number.isFinite(r.id) && r.cents > 0)
      .sort((a, b) => a.cents - b.cents);
    return ladder.length > 1 ? ladder : null;
  })();

  const priceStepUp = (unitTotal) => {
    if (!variantLadder) return null;
    const want = Math.round(Number(unitTotal) * 100);
    return variantLadder.find((r) => r.cents >= want) || null;
  };

  const chargeableUnit = (unitTotal) => {
    const hit = priceStepUp(unitTotal);
    return hit ? hit.cents / 100 : Number(unitTotal);
  };

  const cartProperties = () => {
    const C = S.cart;
    const props = {};
    CONFIG.dimensions.forEach((d) => {
      props[d.key + ' – ' + d.label] = state.dimensions[d.key] + ' ' + C.unit;
    });
    const tier = tierById(state.tierId);
    props[C.fabric] = tier.name;
    props[C.color] = state.colors[tier.id];
    if (state.personalization.type === 'text') {
      props[C.personalization] = S.personalizationText;
      props[C.personalizationText] = state.personalization.text;
      props[C.personalizationFont] = state.personalization.font;
      props[C.personalizationColor] = state.personalization.color;
      props[C.personalizationSides] = state.personalization.sides.join(', ');
    } else if (state.personalization.type === 'logo') {
      props[C.personalization] = S.personalizationLogo;
      props[C.personalizationLogo] = state.personalization.logoFileName || '';
      props[C.personalizationSides] = state.personalization.sides.join(', ');
    }
    const tie = CONFIG.tieDowns.find((t) => t.id === state.tieDown);
    if (tie) props[C.tieDown] = tie.label;
    const grom = CONFIG.grommets.find((g) => g.id === state.grommets);
    if (grom) props[C.grommets] = grom.label;
    if (files.length) props[C.referenceImages] = files.map((f) => f.file.name).join(', ');
    if (state.specialRequest) props[C.specialRequest] = state.specialRequest;
    if (!variantLadder) props[C.configuredPrice] = formatPrice(breakdown(tier).lineTotal);
    const pageUrl = root.getAttribute('data-ccfg-page-url');
    if (pageUrl) props._configurator_url = pageUrl;
    return props;
  };

  const addToCart = () => {
    if (submitting) return;
    if (!allValid()) {
      const firstInvalid = DIM_KEYS.find((k) => !isValidDim(state.dimensions[k]));
      showError(firstInvalid, true);
      refs.inputs[firstInvalid].scrollIntoView({ block: 'center', behavior: 'smooth' });
      refs.inputs[firstInvalid].focus();
      return;
    }
    const unitTotal = breakdown(tierById(state.tierId)).unitTotal;
    const step = priceStepUp(unitTotal);
    if (ladderDeclared && !step) {
      status.textContent = variantLadder ? S.cartOverMax : S.cartError;
      if (!variantLadder) console.error('[cover-configurator] price ladder unusable; refusing to add at the fallback variant price.');
      return;
    }
    const lineVariantId = step ? step.id : variantId;
    const properties = cartProperties();
    if (typeof CONFIG.onAddToCart === 'function') {
      CONFIG.onAddToCart({ variantId: lineVariantId, quantity: state.quantity, properties: properties });
      return;
    }
    if (!Number.isFinite(lineVariantId)) {
      console.error('[cover-configurator] no cart product selected. Pick one in the section settings under Purchase > Cart product.');
      status.textContent = S.cartError;
      return;
    }
    submitting = true;
    status.textContent = S.addingToCart;
    stickyAtc.setAttribute('aria-busy', 'true');
    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: lineVariantId, quantity: state.quantity, properties: properties }] })
    })
      .then((res) => {
        if (!res.ok) return res.json().then((body) => Promise.reject(body));
        try {
          localStorage.removeItem(CONFIG.storageKey);
        } catch (err) {
          /* storage unavailable */
        }
        window.location.href = cartUrl;
      })
      .catch((err) => {
        console.error('[cover-configurator] cart add failed', err);
        status.textContent = (err && err.description) || S.cartError;
        submitting = false;
        stickyAtc.removeAttribute('aria-busy');
      });
  };

  stickyAtc.addEventListener('click', addToCart);

  function update() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const ready = allValid();
      const tier = tierById(state.tierId);

      const preview = previewDimensions();
      CONFIG.tiers.forEach((t) => {
        refs.tierPrices[t.id].textContent = formatPrice(chargeableUnit(breakdown(t, preview).unitTotal));
        syncSwatches(t);
      });

      selectedTierName.textContent = tier.name;

      const b = breakdown(tier, preview);
      const lineTotal = chargeableUnit(b.unitTotal) * state.quantity;
      stickyTotal.textContent = formatPrice(lineTotal);
      priceLive.textContent = ready ? tier.name + ' ' + formatPrice(lineTotal) : '';

      const c = parseFloat(state.dimensions.C);
      const bWidth = parseFloat(state.dimensions.B);
      warn.hidden = !(Number.isFinite(c) && Number.isFinite(bWidth) && c > bWidth);

      stickyAtc.setAttribute('aria-disabled', String(!ready));
      if (ready) stickyAtc.removeAttribute('title');
      else stickyAtc.setAttribute('title', S.addToCartDisabledHint);

      DIM_KEYS.forEach((k) => {
        refs.fields[k].setAttribute('data-filled', String(isValidDim(state.dimensions[k])));
        syncMarkerFilled(k);
      });

      persist();
    });
  }

  DIM_KEYS.forEach((k) => {
    if (state.dimensions[k] !== '') refs.inputs[k].value = state.dimensions[k];
  });
  CONFIG.tiers.forEach(syncSwatches);
  selectTier(state.tierId);
  update();
}

function applySectionSettings(base, root) {
  const id = root.getAttribute('data-ccfg-settings');
  if (!id) return base;
  const node = document.getElementById(id);
  if (!node) return base;

  let overrides;
  try {
    overrides = JSON.parse(node.textContent);
  } catch (err) {
    console.error('[cover-configurator] section settings are not valid JSON; using defaults.', err);
    return base;
  }

  const isPlainObject = (v) => v && typeof v === 'object' && !Array.isArray(v);
  const merge = (target, patch) => {
    const out = Array.isArray(target) ? target.slice() : { ...target };
    Object.keys(patch).forEach((key) => {
      const value = patch[key];
      if (value === null || value === undefined || value === '') return;
      if (Array.isArray(value)) {
        const cleaned = value.filter((v) => v !== null && v !== undefined && v !== '');
        if (cleaned.length) out[key] = cleaned;
        return;
      }
      if (isPlainObject(value)) {
        out[key] = isPlainObject(out[key]) ? merge(out[key], value) : value;
        return;
      }
      out[key] = value;
    });
    return out;
  };

  const merged = merge(base, overrides);

  if (Array.isArray(overrides.tiers)) {
    merged.tiers = overrides.tiers.map((t, i) => {
      const fallback = base.tiers[i] || base.tiers[0];
      const tier = merge(fallback, t);
      if (!Array.isArray(tier.colors) || !tier.colors.length) tier.colors = fallback.colors;
      if (!Array.isArray(tier.features)) tier.features = [];
      tier.features = tier.features.map((f) => String(f).trim()).filter(Boolean);
      return tier;
    });
  }

  ['tieDowns', 'grommets'].forEach((key) => {
    if (Array.isArray(overrides[key]) && overrides[key].length) merged[key] = overrides[key];
  });

  if (Array.isArray(overrides.galleryImages)) {
    merged.galleryImages = overrides.galleryImages.filter((g) => g && g.src);
  }

  const P = merged.personalization;
  if (P) {
    if (Array.isArray(P.sides) && P.sides.length) {
      P.sides = P.sides.map((v) => String(v).trim()).filter(Boolean);
      const keep = (P.defaultSides || []).filter((v) => P.sides.indexOf(v) > -1);
      P.defaultSides = keep.length ? keep : [P.sides[0]];
    }
    if (Array.isArray(P.fonts) && P.fonts.length) {
      P.fonts = P.fonts.map((v) => String(v).trim()).filter(Boolean);
      if (P.fonts.indexOf(P.defaultFont) === -1) P.defaultFont = P.fonts[0];
    }
  }

  return merged;
}

async function init() {
  const root = document.querySelector('.patio-product-page');
  if (!root) {
    console.error('[cover-configurator] no .patio-product-page element found; nothing mounted.');
    return;
  }

  const resolveUrl = (value, fallback) => {
    const raw = value || fallback;
    try {
      return new URL(raw, document.baseURI).href;
    } catch (err) {
      return raw;
    }
  };
  const configUrl = resolveUrl(root.getAttribute('data-ccfg-config'), './cover-configurator.config.js');
  const pricingUrl = resolveUrl(root.getAttribute('data-ccfg-pricing'), './cover-configurator.pricing.js');

  try {
    const [configModule, pricingModule] = await Promise.all([import(configUrl), import(pricingUrl)]);
    CONFIG = configModule.CONFIG;
    computePrice = pricingModule.computePrice;
    formatPrice = pricingModule.formatPrice;
  } catch (err) {
    console.error('[cover-configurator] could not load config or pricing module.', err);
    return;
  }

  CONFIG = applySectionSettings(CONFIG, root);
  S = CONFIG.strings;
  DIM_KEYS = CONFIG.dimensions.map((d) => d.key);
  mount(root);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
